export default __webpack_public_path__ + "static/media/file2.9d4d7b18.png";